import { globalConfig } from '../config'

export const logoutUser = userProfile => {
  if (!userProfile.email) {
    return [
      localStorage.clear('userInfo', userProfile.email),
      globalConfig.logoutUrl,
    ]
  }
}

export function debounce(func, wait, immediate) {
  var timeout;

  return (...args) => {
    var context = this;

    var later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}

export function checkIsPatient(userMetadata) {
  return Number(userMetadata?.membershipType) === 3000
}
export function checkIsProvider(userMetadata) {
  return Number(userMetadata?.membershipType) === 3001
}
export function checkIsAdmin(userMetadata){
  return Number(userMetadata?.membershipType)===3002
}
export function checkIsSsp(userMetadata) {
	return Number(userMetadata?.membershipType) === 3003
}
/**
 * @description Get name initials
 * eg. Kwesi Yeboah
 *     Kogo Kena
 *     Nana-Yeboah
 *     Leslie 
 * @param name string
 * @return string
 */
export function getNameInitials(name) {
  return name.split(" ").reduce((initials, truncatedName) => {
    if(truncatedName.length > 0) {
      return initials + truncatedName[0].toUpperCase()
    }

    return initials
  }, '')
}